export interface AnimeItem {
  id: string;
  title: string;
  cover: string;
  category: string;
  tags: string[];
  rating: number;
  episodes: string;
  status: string;
  description: string;
  year: number;
  region: string;
}

export interface AnimeCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const animeCategories: AnimeCategory[] = [
  { slug: 'guoman', name: '国漫', icon: 'ri-flag-2-line', description: '精选国产动漫，支持国产原创力量' },
  { slug: 'riman', name: '日漫', icon: 'ri-sun-line', description: '经典日本动漫，热血与日常全收录' },
  { slug: 'meiman', name: '美漫', icon: 'ri-star-line', description: '美式动漫风格，超级英雄与科幻世界' },
  { slug: 'rexue', name: '热血冒险', icon: 'ri-fire-line', description: '燃到爆炸的战斗与冒险之旅' },
  { slug: 'lianai', name: '恋爱日常', icon: 'ri-heart-line', description: '甜蜜温馨的恋爱与校园生活' },
  { slug: 'qihuan', name: '奇幻玄幻', icon: 'ri-magic-line', description: '奇幻异世界与玄幻修真之旅' },
  { slug: 'gaoxiao', name: '搞笑喜剧', icon: 'ri-emotion-laugh-line', description: '让你笑到停不下来的欢乐番剧' },
  { slug: 'kehuan', name: '科幻机战', icon: 'ri-rocket-line', description: '未来科技与机械战争的震撼体验' },
];

export const animeList: AnimeItem[] = [
  {
    id: 'doupo-cangqiong',
    title: '斗破苍穹',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20donghua%20anime%20poster%20style%2C%20young%20martial%20artist%20male%20protagonist%20with%20flame%20energy%20surrounding%20him%2C%20epic%20fantasy%20cultivation%20theme%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20gold%20tones%2C%20simple%20dark%20background%2C%20anime%20art%20style%2C%20clean%20composition&width=600&height=800&seq=anime-doupo&orientation=portrait',
    category: 'guoman',
    tags: ['热血', '玄幻', '修仙'],
    rating: 9.2,
    episodes: '已完结·全104集',
    status: '已完结',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，种种打击接踵而至。就在他即将绝望的时候，一缕灵魂从他手上的戒指里浮现，一扇全新的大门在面前开启。',
    year: 2017,
    region: '中国大陆',
  },
  {
    id: 'yiren-zhixia',
    title: '一人之下',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20poster%2C%20a%20young%20man%20with%20supernatural%20powers%2C%20mysterious%20urban%20fantasy%20setting%2C%20traditional%20Chinese%20elements%20mixed%20with%20modern%20city%2C%20warm%20coral%20and%20dark%20tones%2C%20clean%20simple%20background%2C%20anime%20illustration%20style&width=600&height=800&seq=anime-yiren&orientation=portrait',
    category: 'guoman',
    tags: ['奇幻', '都市', '异能'],
    rating: 9.5,
    episodes: '更新至第5季',
    status: '连载中',
    description: '随着爷爷的尸体被盗，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。急于解开爷爷和自身秘密的张楚岚，与没有任何记忆的"不死少女"冯宝宝开启了"异人"之旅。',
    year: 2016,
    region: '中国大陆',
  },
  {
    id: 'fanren-xiuxian',
    title: '凡人修仙传',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20poster%2C%20a%20male%20cultivator%20in%20traditional%20Chinese%20robe%2C%20immortal%20cultivation%20theme%2C%20mountain%20and%20cloud%20landscape%2C%20mystical%20atmosphere%2C%20warm%20golden%20and%20jade%20green%20tones%2C%20clean%20background%2C%20anime%20art%20style&width=600&height=800&seq=anime-fanren&orientation=portrait',
    category: 'guoman',
    tags: ['修仙', '奇幻', '冒险'],
    rating: 9.3,
    episodes: '更新至第76集',
    status: '连载中',
    description: '一个普通的山村穷小子，偶然之下，跨入到一个江湖小门派，虽然资质平庸，但依靠自身努力和合理算计最后修炼成仙。',
    year: 2020,
    region: '中国大陆',
  },
  {
    id: 'yaojing-wei',
    title: '镖人',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20poster%2C%20a%20fierce%20warrior%20with%20sword%20in%20desert%20setting%2C%20historical%20martial%20arts%20theme%2C%20dusty%20warm%20sand%20tones%2C%20dramatic%20action%20pose%2C%20simple%20background%2C%20anime%20illustration%20style&width=600&height=800&seq=anime-biaoren&orientation=portrait',
    category: 'guoman',
    tags: ['武侠', '历史', '动作'],
    rating: 9.0,
    episodes: '更新至第15集',
    status: '连载中',
    description: '大业三年（公元607年），隋王朝在隋炀帝杨广的残暴统治下民不聊生。身手不凡的镖客刀马行走于西域大漠，在躲避朝廷追杀的途中，他接下了一个目的地为首都长安的护送任务。',
    year: 2023,
    region: '中国大陆',
  },
  {
    id: 'jujutsu-kaisen',
    title: '咒术回战',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20style%2C%20young%20sorcerer%20male%20protagonist%20with%20dark%20energy%2C%20supernatural%20battle%20theme%2C%20urban%20fantasy%20setting%2C%20dramatic%20red%20and%20black%20tones%2C%20clean%20simple%20background%2C%20modern%20anime%20art&width=600&height=800&seq=anime-jujutsu&orientation=portrait',
    category: 'riman',
    tags: ['热血', '战斗', '奇幻'],
    rating: 9.4,
    episodes: '第2季已完结',
    status: '已完结',
    description: '高中生虎杖悠仁的祖父在去世前嘱咐他要尽可能帮助他人，并希望他在众人簇拥下死去。虎杖悠仁在经历一系列事件后加入了东京都立咒术高等专门学校，开始了与咒灵的战斗。',
    year: 2020,
    region: '日本',
  },
  {
    id: 'kimetsu-no-yaiba',
    title: '鬼灭之刃',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%2C%20young%20demon%20slayer%20male%20protagonist%20with%20sword%2C%20traditional%20Japanese%20setting%2C%20epic%20battle%20theme%2C%20water%20breathing%20effects%2C%20blue%20and%20crimson%20tones%2C%20simple%20dark%20background%2C%20anime%20art%20style&width=600&height=800&seq=anime-kimetsu&orientation=portrait',
    category: 'riman',
    tags: ['热血', '战斗', '历史'],
    rating: 9.3,
    episodes: '已完结·全63集',
    status: '已完结',
    description: '时值日本大正时期，传说太阳下山后，有恶鬼出没吃人。卖炭少年炭治郎的家人全遭鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。被绝望打击的炭治郎为了寻找让妹妹恢复的方法，踏上了斩鬼之旅。',
    year: 2019,
    region: '日本',
  },
  {
    id: 'spy-x-family',
    title: '间谍过家家',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20style%2C%20a%20family%20of%20three%20including%20a%20spy%20man%2C%20assassin%20woman%2C%20and%20telepathic%20girl%2C%20comedy%20spy%20theme%2C%20warm%20family%20atmosphere%2C%20pastel%20pink%20and%20cream%20tones%2C%20clean%20background%2C%20anime%20illustration&width=600&height=800&seq=anime-spy&orientation=portrait',
    category: 'riman',
    tags: ['搞笑', '日常', '间谍'],
    rating: 9.1,
    episodes: '第3季更新中',
    status: '连载中',
    description: '为了潜入名校，西国能力最强的间谍"黄昏"被下令组建家庭。但他找到的"女儿"居然是会读心的超能力者，"妻子"是暗杀者。三人互相隐瞒真实身份，开始了临时家庭生活。',
    year: 2022,
    region: '日本',
  },
  {
    id: 'one-piece',
    title: '海贼王',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%2C%20pirate%20boy%20with%20straw%20hat%2C%20adventure%20on%20the%20sea%2C%20epic%20pirate%20theme%2C%20blue%20ocean%20and%20golden%20sunset%20tones%2C%20grand%20adventure%20feeling%2C%20clean%20background%2C%20anime%20art%20style&width=600&height=800&seq=anime-onepiece&orientation=portrait',
    category: 'riman',
    tags: ['热血', '冒险', '友情'],
    rating: 9.6,
    episodes: '更新至第1100+集',
    status: '连载中',
    description: '传奇海盗哥尔·D·罗杰在临死前留下关于其毕生财富"One Piece"的消息，引得群雄并起，众海盗们纷纷寻找这笔传说中的巨额财富，各种势力、政权不断交替，整个世界进入了动荡混乱的"大海贼时代"。',
    year: 1999,
    region: '日本',
  },
  {
    id: 'arcane',
    title: '双城之战',
    cover: 'https://readdy.ai/api/search-image?query=American%20animated%20series%20poster%20style%2C%20two%20sisters%20in%20steampunk%20city%2C%20dramatic%20conflict%20theme%2C%20dark%20and%20neon%20purple%20and%20gold%20tones%2C%20painterly%20art%20style%2C%20clean%20background%2C%20League%20of%20Legends%20inspired&width=600&height=800&seq=anime-arcane&orientation=portrait',
    category: 'meiman',
    tags: ['科幻', '动作', '剧情'],
    rating: 9.5,
    episodes: '第2季更新中',
    status: '连载中',
    description: '《双城之战》的故事基于英雄联盟宇宙，讲述了皮尔特沃夫和祖安这两座截然不同的城市中，蔚和金克丝两姐妹之间的故事。她们身处科技与魔法的冲突之中，各自的命运也因此走向了截然不同的方向。',
    year: 2021,
    region: '美国',
  },
  {
    id: 'invincible',
    title: '无敌少侠',
    cover: 'https://readdy.ai/api/search-image?query=American%20animated%20superhero%20poster%2C%20young%20male%20hero%20in%20blue%20and%20yellow%20costume%20flying%2C%20superhero%20action%20theme%2C%20dramatic%20sky%20background%2C%20bold%20comic%20book%20art%20style%2C%20clean%20composition&width=600&height=800&seq=anime-invincible&orientation=portrait',
    category: 'meiman',
    tags: ['超级英雄', '动作', '科幻'],
    rating: 9.0,
    episodes: '第2季已完结',
    status: '已完结',
    description: '马克·格雷森是一个普通青少年，除了他的父亲是地球上最强大的超级英雄全能侠之外。但在马克十七岁生日后不久，他开始发展出自己的超能力，并进入了他父亲的门下学习。',
    year: 2021,
    region: '美国',
  },
  {
    id: 'xinghe-baozou',
    title: '星核猎手',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20poster%2C%20sci-fi%20space%20adventure%2C%20mecha%20and%20starship%2C%20young%20pilot%20protagonist%2C%20futuristic%20space%20setting%2C%20cool%20silver%20and%20deep%20blue%20tones%2C%20clean%20simple%20background%2C%20anime%20style&width=600&height=800&seq=anime-xinghe&orientation=portrait',
    category: 'kehuan',
    tags: ['科幻', '机战', '冒险'],
    rating: 8.8,
    episodes: '更新至第32集',
    status: '连载中',
    description: '在遥远的未来，人类已经遍布银河系。少年林星在偶然间获得了一台神秘机甲的驾驶权，从此踏上了星际冒险的征途，揭开宇宙深处的秘密。',
    year: 2024,
    region: '中国大陆',
  },
  {
    id: 'dakaila',
    title: '打了三百年的史莱姆',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20style%2C%20cute%20witch%20girl%20in%20fantasy%20world%2C%20comedy%20slice%20of%20life%20theme%2C%20pastel%20warm%20colors%2C%20magical%20forest%20background%2C%20lighthearted%20atmosphere%2C%20clean%20simple%20composition%2C%20anime%20illustration&width=600&height=800&seq=anime-slime&orientation=portrait',
    category: 'gaoxiao',
    tags: ['搞笑', '日常', '奇幻'],
    rating: 8.5,
    episodes: '已完结·全12集',
    status: '已完结',
    description: '社畜相泽梓因工作过度而过劳死，转生到异世界成为了不老不死的魔女。她决定享受慢生活，花了三百年每天打史莱姆升到了满级。然而她的名声却意外传开了。',
    year: 2021,
    region: '日本',
  },
];

export interface Article {
  id: string;
  title: string;
  cover: string;
  category: string;
  tags: string[];
  author: string;
  publishDate: string;
  readCount: number;
  summary: string;
  content: string;
}

export const articles: Article[] = [
  {
    id: '2024-summer-anime-guide',
    title: '2024夏季新番推荐：十部必看热门动漫大盘点',
    cover: 'https://readdy.ai/api/search-image?query=Summer%20anime%20collage%20with%20multiple%20anime%20characters%2C%20vibrant%20colorful%20summer%20aesthetic%2C%20anime%20style%20illustration%2C%20festive%20atmosphere%2C%20warm%20golden%20sunset%20lighting%2C%20clean%20composition%2C%20horizontal%20banner%20format&width=1200&height=600&seq=article-summer&orientation=landscape',
    category: 'riman',
    tags: ['新番', '推荐', '日漫'],
    author: '动漫小助手',
    publishDate: '2024-07-15',
    readCount: 52860,
    summary: '2024年夏季新番阵容强大，本文为大家精选十部不容错过的热门作品，从热血战斗到温馨日常，总有一款适合你。',
    content: `<h2>引言</h2>
<p>随着2024年夏季的到来，又一批精彩的新番动画即将与观众见面。本季度的作品涵盖热血战斗、恋爱喜剧、奇幻冒险等多种题材，满足不同观众的追番需求。下面就让我们一起来看看本季度最值得期待的十部作品吧。</p>

<h2>1. 《咒术回战》第3季</h2>
<p>作为近年来最热门的少年战斗番，《咒术回战》第3季将迎来更为激烈的"死灭回游"篇。芥见下下老师笔下错综复杂的咒术世界将进一步展开，虎杖悠仁、伏黑惠与钉崎野蔷薇三人组的命运也将迎来重大转折。</p>
<p><strong>推荐理由：</strong>顶级的战斗场面制作，深刻的人物刻画，以及引人入胜的世界观构建。</p>

<h2>2. 《葬送的芙莉莲》新篇</h2>
<p>这部在2023年秋季引发巨大话题的作品，凭借其独特的叙事方式和感人至深的情感表达获得了广泛好评。新篇章将继续讲述芙莉莲的旅途，更多关于魔法与人性之间的故事等待被揭开。</p>
<p><strong>推荐理由：</strong>细腻的情感描写，精美的画面制作，以及对"时间"与"羁绊"的深度探讨。</p>

<h2>3. 《间谍过家家》新季度</h2>
<p>佛杰一家的冒险仍在继续！这部融合了间谍动作与家庭喜剧的独特作品，凭借可爱的人物设定和轻松愉快的剧情赢得了全球观众的喜爱。新季度将加入更多新角色，家庭的羁绊也将进一步加深。</p>
<p><strong>推荐理由：</strong>轻松愉快的观感体验，可爱到爆炸的安妮亚，以及出其不意的笑点设计。</p>

<h2>4. 《怪兽8号》</h2>
<p>改编自松本直也原作的热门漫画，讲述了一个在怪兽清扫队工作的中年男子意外获得了变身怪兽的能力，从而实现了加入防卫队的梦想。这部作品既有震撼的怪兽战斗场面，也有关于梦想与坚持的温情故事。</p>
<p><strong>推荐理由：</strong>独特的怪兽题材设定，精彩的战斗分镜，以及中年追梦的热血故事。</p>

<h2>5. 《我推的孩子》第2季</h2>
<p>赤坂明与横枪萌果联手打造的这部现象级作品，讲述了转生成为偶像孩子的阿库亚与露比在演艺圈的奋斗故事。第2季将深入展开演艺圈背后的黑暗面与角色之间的复杂关系。</p>
<p><strong>推荐理由：</strong>独特的故事设定，对演艺圈的深刻洞察，以及令人欲罢不能的剧情发展。</p>

<h2>总结</h2>
<p>2024年夏季新番的整体质量非常值得期待，无论你是资深动漫迷还是刚刚入坑的新人，都能在这个夏天找到属于自己的那份动漫乐趣。以上推荐的作品各有特色，建议大家根据个人喜好选择观看。祝大家追番愉快！</p>`,
  },
  {
    id: 'chinese-anime-rise',
    title: '国漫崛起：从模仿到创新的蜕变之路',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20collage%20with%20various%20donghua%20characters%2C%20epic%20Chinese%20fantasy%20style%2C%20traditional%20Chinese%20elements%2C%20warm%20golden%20and%20red%20tones%2C%20patriotic%20and%20inspiring%20atmosphere%2C%20clean%20composition%2C%20horizontal%20banner&width=1200&height=600&seq=article-guoman&orientation=landscape',
    category: 'guoman',
    tags: ['国漫', '行业分析', '推荐'],
    author: '动漫观察家',
    publishDate: '2024-08-02',
    readCount: 38720,
    summary: '近年来，国产动漫取得了长足进步，从画面质量到故事内容都有了质的飞跃。本文将回顾国漫的发展历程，盘点具有里程碑意义的代表作品。',
    content: `<h2>国漫的发展历程</h2>
<p>回顾过去十年，国产动漫经历了一个从量变到质变的过程。从早期的模仿日美风格，到如今形成具有中国特色的动漫美学体系，国漫正在用实力证明自己。</p>

<h2>里程碑作品</h2>
<p><strong>《大圣归来》（2015）</strong>被誉为国漫复兴的开端之作。这部动画电影以9.56亿的票房成绩打破了国产动画电影的纪录，更让业界看到了国产动画的商业潜力。</p>
<p>随后，《大鱼海棠》《白蛇：缘起》《哪吒之魔童降世》等一系列优质动画电影相继问世，不仅在国内取得了亮眼的票房成绩，更在国际市场上崭露头角。</p>

<h2>网文改编的成功之路</h2>
<p>在番剧领域，《斗破苍穹》《斗罗大陆》《凡人修仙传》等网文改编作品凭借庞大的原著粉丝基础和精良的制作，迅速占领了市场。这些作品在画面表现、动作设计、配音配乐等方面都有了显著提升。</p>

<h2>原创力量的崛起</h2>
<p>除了改编作品，像《时光代理人》《刺客伍六七》《罗小黑战记》等原创国漫也展现出了强大的创造力。它们在题材选择、叙事手法和艺术风格上都有独特的探索，为国漫的多元化发展注入了新的活力。</p>

<h2>展望未来</h2>
<p>国漫正处于最好的发展时期。随着制作技术的不断进步、人才队伍的持续壮大、以及资本市场的日益成熟，我们有理由相信，国漫的明天会更加辉煌。</p>`,
  },
  {
    id: 'anime-music-recommend',
    title: '那些让人单曲循环的动漫神曲TOP20',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20music%20concert%20theme%2C%20colorful%20musical%20notes%20floating%2C%20anime%20characters%20singing%2C%20vibrant%20and%20energetic%20atmosphere%2C%20warm%20lighting%2C%20concert%20stage%20background%2C%20anime%20style%20illustration%2C%20clean%20horizontal%20banner&width=1200&height=600&seq=article-music&orientation=landscape',
    category: 'riman',
    tags: ['音乐', '盘点', '日漫'],
    author: '动漫小助手',
    publishDate: '2024-07-28',
    readCount: 45210,
    summary: '一首好的动漫歌曲不仅能提升作品的感染力，更能成为一代人的青春记忆。本文盘点那些让人一听就停不下来的经典动漫神曲。',
    content: `<h2>前言</h2>
<p>动漫音乐是日本流行音乐的重要组成部分，许多动漫主题曲不仅在日本国内广受欢迎，更在全球范围内拥有大量粉丝。一首优秀的动漫歌曲，往往能在听到前奏的瞬间就将人的思绪拉回到那个故事之中。</p>

<h2>神曲盘点（部分）</h2>
<h3>1. 红莲华 - LiSA（《鬼灭之刃》）</h3>
<p>这首《鬼灭之刃》的片头曲在日本Oricon榜单上多次登顶，其燃爆的节奏和LiSA充满力量的演唱完美契合了作品的热血主题。</p>

<h3>2. 青鸟 - 生物股长（《火影忍者疾风传》）</h3>
<p>"蓝蓝天空，我张开翅膀飞翔~"这首歌伴随了无数90后的青春岁月，每当旋律响起，仿佛又回到了那个追火影的夏天。</p>

<h3>3. 前前前世 - RADWIMPS（《你的名字。》）</h3>
<p>新海诚导演与RADWIMPS的完美合作，这首歌曲与电影画面浑然天成，将跨越时空的爱情故事演绎得淋漓尽致。</p>

<h3>4. Gurenge - LiSA（《鬼灭之刃》）</h3>
<p>这首歌打破了多项日本音乐纪录，成为2019年最畅销的数字单曲。LiSA用她标志性的嗓音将炭治郎的决心与坚韧完美呈现。</p>

<h3>5. 直到世界尽头 - WANDS（《灌篮高手》）</h3>
<p>作为三井寿的角色曲，这首歌在华语圈拥有极高的传唱度。那句"教练，我想打篮球"配合这首歌的旋律，成为了无数人的青春记忆。</p>

<h2>结语</h2>
<p>好的动漫音乐能够跨越语言和文化的障碍，直击人心。希望这份榜单能唤起你对某些作品的美好回忆，也欢迎在评论区分享你心目中的动漫神曲。</p>`,
  },
  {
    id: 'donghua-vs-anime',
    title: '国漫VS日漫：两者之间的差异与共通之处',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20versus%20Japanese%20anime%20comparison%2C%20two%20sides%20with%20different%20art%20styles%2C%20split%20screen%20design%2C%20warm%20versus%20cool%20color%20palette%2C%20cultural%20elements%20from%20both%20countries%2C%20clean%20composition%2C%20horizontal%20banner&width=1200&height=600&seq=article-vs&orientation=landscape',
    category: 'guoman',
    tags: ['对比', '国漫', '日漫', '分析'],
    author: '动漫观察家',
    publishDate: '2024-07-20',
    readCount: 29850,
    summary: '随着国漫的快速发展，越来越多的观众开始将国漫与日漫进行比较。本文从制作风格、叙事方式、文化底蕴等多个维度进行深入分析。',
    content: `<h2>制作风格差异</h2>
<p>日漫经过数十年的发展，已经形成了成熟的工业体系。其制作流程标准化程度高，从原画到上色再到后期，每个环节都有明确的分工和质量标准。而国漫虽然起步较晚，但凭借3DCG技术的弯道超车，在视觉效果上已经达到了国际水准。</p>

<h2>叙事方式对比</h2>
<p>日漫在叙事上更加注重人物内心世界的刻画，常常通过细腻的表情变化和留白来传递情感。而国漫则更倾向于直白的叙事方式，情节推进节奏较快，这与国内观众长期养成的观剧习惯有关。</p>

<h2>文化底蕴的体现</h2>
<p>国漫最大的优势在于深厚的中华文化底蕴。无论是修真体系、武侠精神还是传统美学，都为国漫提供了取之不尽的创作素材。日漫则更多融入了日本的武士道精神、妖怪文化等本土元素。</p>

<h2>共通的动漫精神</h2>
<p>无论是国漫还是日漫，它们共同承载着"热血、友情、努力"的动漫精神。那些关于成长、梦想和羁绊的故事，无论出自哪个国家，都能打动观众的心。</p>

<h2>未来趋势</h2>
<p>随着全球化的深入，国漫与日漫之间的界限正在逐渐模糊。越来越多的合作项目、联合制作正在打破国界的限制，为全球动漫爱好者带来更多优质内容。</p>`,
  },
];

export const siteInfo = {
  name: '91动漫',
  slogan: '随时随地，畅享动漫世界',
  description: '91动漫是专注动漫爱好者的在线观看平台，汇聚海量国漫、日漫、美漫资源，支持高清免费播放。无论你喜欢热血冒险、恋爱日常还是奇幻玄幻，91动漫都能满足你的追番需求。',
  founded: '2020年',
  email: 'contact@91anime.com',
  wechat: 'anime91_official',
  qq: '800123456',
};

export const testimonials = [
  {
    name: '小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20simple%20warm%20background%2C%20clean%20headshot%20photography&width=100&height=100&seq=avatar-01&orientation=squarish',
    role: '资深动漫爱好者',
    content: '用了91动漫三年了，资源真的很全，更新速度也快。无论是国漫还是日漫，想看的基本都能找到，已经推荐给身边所有追番的朋友了。',
    rating: 5,
  },
  {
    name: '小李',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20warm%20smile%2C%20modern%20casual%20style%2C%20clean%20bright%20background%2C%20professional%20headshot%20photography&width=100&height=100&seq=avatar-02&orientation=squarish',
    role: '大学生',
    content: '画质真的没话说，720P和1080P随便切换，网速好的时候看蓝光画质简直是一种享受。弹幕氛围也很友好，追番体验满分。',
    rating: 5,
  },
  {
    name: '老张',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%2C%20gentle%20smile%2C%20business%20casual%20style%2C%20simple%20warm%20background%2C%20clean%20headshot%20photography&width=100&height=100&seq=avatar-03&orientation=squarish',
    role: 'IT工程师',
    content: '从火影追到海贼，从国漫追到日漫，91动漫见证了我十几年的追番历程。界面简洁好用，分类清晰，找番特别方便。',
    rating: 5,
  },
  {
    name: '小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20portrait%2C%20bright%20smile%2C%20casual%20fashion%20style%2C%20clean%20pastel%20background%2C%20fresh%20headshot%20photography&width=100&height=100&seq=avatar-04&orientation=squarish',
    role: '设计师',
    content: '最喜欢91动漫的分类功能，按类型、地区、年份筛选都很方便。而且推荐算法很精准，经常能发现一些冷门好番。',
    rating: 5,
  },
];

export const faqs = [
  {
    question: '91动漫是否需要注册才能观看？',
    answer: '不需要。91动漫所有动漫资源均支持免注册免费在线观看。如果您希望使用弹幕互动、收藏追番等功能，注册账号后将获得更完整的追番体验。',
  },
  {
    question: '91动漫支持哪些画质播放？',
    answer: '91动漫支持流畅（360P）、标清（480P）、高清（720P）、超清（1080P）以及蓝光画质。您可以根据网络情况和个人需求自由切换画质，享受最佳的观看体验。',
  },
  {
    question: '91动漫的资源更新速度快吗？',
    answer: '非常快。我们的更新团队会在动漫更新的第一时间进行同步，通常在日本播出后数小时内即可上线中文字幕版本，确保您不会错过任何精彩内容。国漫方面也保持与官方同步更新的节奏。',
  },
  {
    question: '91动漫支持手机观看吗？',
    answer: '完全支持。91动漫采用响应式设计，完美适配手机、平板、电脑等多种设备。您可以在任何设备上获得流畅的观看体验，随时随地畅享动漫世界。',
  },
  {
    question: '如何联系91动漫的客服？',
    answer: '您可以通过以下方式联系我们：发送邮件至 contact@91anime.com，或添加官方微信 anime91_official，也可以加入官方QQ群 800123456。我们的客服团队会在第一时间为您解答问题。',
  },
  {
    question: '91动漫有App吗？',
    answer: '目前91动漫主要通过Web端提供服务，iOS和Android App正在紧锣密鼓地开发中，预计将于近期上线，敬请期待。Web端目前已经完美适配移动设备，您可以先通过浏览器访问使用。',
  },
];